module.exports = __webpack_public_path__ + "media/images/athletes/1313-b4560e7af5f5a6783898f6a721001718.png";